import caseInfo from '../pantentInfo/caseInfo.vue'
import claim from '../pantentInfo/claim.vue'
import direction from '../pantentInfo/direction.vue'
import homedogy from '../pantentInfo/homdogy.vue'
import patentImage from './patentImage.vue'
import law from '../pantentInfo/law.vue'
import pantentBase from '@/views/search/pantentInfo/pantentBase.vue'
import  pdf from '../pantentInfo/pdf.vue'
import quote from '../pantentInfo/quote.vue'
import similarity from '../pantentInfo/similarity.vue'

export default{
    components:{
        caseInfo,
        claim,
        direction,
        homedogy,
        patentImage,
        law,
        pantentBase,
        pdf,
        quote,
        similarity
    }
}

